// src/store/modules/seo.js
import { fetchSiteInfo } from '@/api/common.js';

const state = {
  siteInfo: null
}

const getters = {
  siteName: state => state.siteInfo?.siteName || '',
  siteDescription: state => state.siteInfo?.siteIntroduction || '',
  siteKeywords: state => state.siteInfo?.siteKeywords || ''
}

const actions = {
  async initSiteInfo({ commit }) {
    try {
      const response = await fetchSiteInfo();
      if (response && response.resultCode === '200' && response.resultData) {
        commit('SET_SITE_INFO', response.resultData);
      }
    } catch (error) {
      console.error('Failed to fetch site info:', error);
    }
  }
}

const mutations = {
  SET_SITE_INFO(state, siteInfo) {
    state.siteInfo = siteInfo;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}